import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";
import TablePagination from "../../../../Components/Molecules/Pagination";
import NoRecords from "../../../../Components/Atoms/NoRecord";
import toast from "react-hot-toast";
import { Edit } from "@mui/icons-material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { CircularProgress } from "@mui/material";
import AvailableStatus from "../../../../Components/Atoms/AvailableStatus";
import CustomButton from "../../../../Components/Atoms/CustomButton";
import CustomDialog from "../../../../Components/Molecules/CustomDialog";
import {
  getMasterListRequest,
  postMasterResponseClear,
  putStatusMasterRequest,
} from "../../../../Redux/Master/MasterActions";
import CreateMaster from "../CreateMaster";
import { MASTER_SETTINGS } from "../../../../Constant";

const IndexClient = ({ permissions }) => {
  const dispatch = useDispatch();
  const {
    getMasterListLoading,
    getMasterListResponse,
    postMasterLoading,
    postMasterResponse,
  } = useSelector((state) => state.masterReducer);
  const [page, setPage] = useState(1);
  const searchSchema = {
    filters: {
      search: {
        value: "",
      },
      type: {
        value: MASTER_SETTINGS.CLIENT,
      },
    },
    limit: 10,
    page: page,
    sort: "",
  };

  const searchFormik = useFormik({
    initialValues: searchSchema,
    onSubmit: (values) => {
      setPage(1);
      return dispatch(getMasterListRequest(values));
    },
  });

  useEffect(() => {
    if (postMasterLoading) return;
    dispatch(getMasterListRequest({ ...searchFormik.values, page }));
  }, [page, postMasterLoading]);

  useEffect(() => {
    if (postMasterResponse?.success && postMasterResponse?.message) {
      toast.success(postMasterResponse?.message);
      handleClose();
    } else if (postMasterResponse?.response?.data) {
      toast.error(postMasterResponse?.response?.data?.message);
    }

    return () => {
      dispatch(postMasterResponseClear());
    };
  }, [postMasterResponse]);

  //
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  const handleOpen = (e = null) => {
    setOpen(true);
    setData(e);
  };

  const handleClose = () => {
    setOpen(false);
    setData(null);
  };

  return (
    <>
      <CustomDialog
        maxWidth="md"
        title={data ? "UPDATE CLIENT" : "CREATE CLIENT"}
        handleClose={handleClose}
        open={open}
      >
        <div>
          <CreateMaster
            handleClose={handleClose}
            data={data}
            type={MASTER_SETTINGS.CLIENT}
          />
        </div>
      </CustomDialog>

      <div className="d-flex-juscon-flex-end-align-center mb-10">
        {permissions.CREATE && (
          <CustomButton
            label={"New Client"}
            size="small"
            onClick={() => handleOpen()}
            action={"NEW"}
          />
        )}
      </div>
      {getMasterListLoading && !getMasterListLoading?.data?.length > 0 ? (
        <div className="d-flex align-items-center justify-content-center">
          <CircularProgress size={25} />
        </div>
      ) : (
        <TablePagination
          showFilter={true}
          showSort={true}
          setPage={setPage}
          page={page}
          initialValues={searchSchema}
          formik={searchFormik}
          action={(values) => dispatch(getMasterListRequest(values))}
          result={getMasterListResponse}
          count={getMasterListResponse?.data?.total_count}
        >
          <div className="tblWrpr">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>UUID</th>
                    <th>NAME</th>
                    <th>STATUS</th>
                    <th>CREATED BY</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {getMasterListResponse?.data?.length > 0 ? (
                    getMasterListResponse?.data?.map((data, index) => {
                      return (
                        <tr key={data._id}>
                          <td>
                            {searchFormik?.values?.limit * (page - 1) +
                              index +
                              1}
                          </td>

                          <td>{data?._id}</td>
                          <td>{data?.name}</td>
                          <td>
                            <AvailableStatus
                              status={data?.status}
                              customCls={
                                data?.status === "ACTIVE"
                                  ? "index-green"
                                  : "index-red"
                              }
                            />
                          </td>
                          <td>{data?.created_by?.first_name}</td>
                          <td>
                            <div className="view">
                              {permissions.STATUS && (
                                <button
                                  onClick={() => {
                                    dispatch(
                                      putStatusMasterRequest({
                                        id: data?._id,
                                        status:
                                          data?.status === "ACTIVE"
                                            ? "INACTIVE"
                                            : "ACTIVE",
                                      })
                                    );
                                  }}
                                >
                                  {data.status === "ACTIVE" ? (
                                    <RemoveCircleOutlineIcon />
                                  ) : (
                                    <DoneIcon />
                                  )}
                                </button>
                              )}
                              {permissions.UPDATE && (
                                <button onClick={() => handleOpen(data)}>
                                  <Edit />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NoRecords />
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </TablePagination>
      )}
    </>
  );
};

export default IndexClient;
